"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.action('ONE_RECIPIENT_SELECTED_ACTION', function (persona) {
    return {
        persona: persona,
    };
});
//# sourceMappingURL=oneRecipientSelectedAction.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-subject-picker-store/lib/actions/oneRecipientSelectedAction.js
// module id = 2048
// module chunks = 2 3 4 45 108